<!-- eslint-disable vue/multi-word-component-names -- single-word SFC name matches the route, renaming breaks router refs -->
<script setup lang="ts">
import axiosClient from '@/axios'
import PageBreadcrumb from '@/components/common/PageBreadcrumb.vue'
import { onMounted, reactive, ref } from 'vue'
import { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'

const userProfile = reactive({
  email: '',
  id: 0,
  password: '',
})

const password = ref('')
const password_r = ref('')

const showSuccess = ref(false)
const showFailed = ref(false)

function changePassword() {
  if (password.value == password_r.value && password.value != '' && password_r.value != '') {
    userProfile.password = password.value
    axiosClient
      .put('/admins/' + userProfile.id + '/password/change', { password: userProfile.password })
      .then(({ data }) => {
        showSuccess.value = true
        showFailed.value = false
      })
      .catch(function (error) {
        toast.error('Chyba: ' + error.toJSON())
        showSuccess.value = false
        showFailed.value = true
      })
  } else {
    showSuccess.value = false
    showFailed.value = true
  }
}

onMounted(() => {
  return axiosClient.get('/admins/profile').then(({ data }) => {
    userProfile.email = data.user.email
    userProfile.id = data.user.id
    return data
  })
})
</script>

<template>
  <header class="bg-white shadow-xs dark:bg-white/3">
    <div class="max-w-(--breakpoint-2xl) mx-auto py-6">
      <PageBreadcrumb page-title="Váš profil" />
    </div>
  </header>
  <main>
    <div class="max-w-(--breakpoint-2xl) mx-auto py-6">
      <div class="px-4 py-6 sm:px-0">
        <div class="mt-10 sm:mt-0">
          <div class="md:grid md:grid-cols-3 md:gap-6">
            <div class="md:col-span-1">
              <div class="px-4 sm:px-0">
                <h3 class="text-lg font-medium leading-6 text-gray-900 dark:text-white/90">Osobné informácie</h3>
              </div>
            </div>
            <div class="mt-5 md:mt-0 md:col-span-2">
              <div class="shadow-xs overflow-hidden sm:rounded-md">
                <div class="px-4 py-5 bg-white sm:p-6 dark:bg-white/3">
                  <div class="grid grid-cols-6 gap-6">
                    <div class="col-span-6 sm:col-span-4">
                      <label for="email-address" class="block text-sm font-medium text-gray-700 dark:text-gray-300">Email</label>
                      <label>{{ userProfile.email }}</label>
                      <form class="py-4" @submit.prevent="changePassword()">
                        <div class="shadow-xs overflow-hidden sm:rounded-md">
                          <div class="px-4 py-5 bg-white sm:p-6 dark:bg-white/3">
                            <div class="grid grid-cols-6 gap-6">
                              <div class="col-span-6 sm:col-span-4">
                                <label for="title" class="block text-sm font-medium text-gray-700 dark:text-gray-300">Nové heslo</label>
                                <FormKit
                                  v-model="password"
                                  type="password"
                                  name="title"
                                  id="title"
                                  class="mt-1 focus:ring-brand-500 focus:border-brand-500 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md dark:border-gray-700"
                                />
                              </div>

                              <div class="col-span-6 sm:col-span-4">
                                <label for="content" class="block text-sm font-medium text-gray-700 dark:text-gray-300"
                                  >Zopakujte nové heslo</label
                                >
                                <FormKit
                                  v-model="password_r"
                                  type="password"
                                  name="content"
                                  id="content"
                                  class="mt-1 focus:ring-brand-500 focus:border-brand-500 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md dark:border-gray-700"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="px-4 py-3 bg-gray-50 text-right sm:px-6 dark:bg-white/3">
                            <button
                              type="submit"
                              class="inline-flex justify-center py-2 px-4 border border-transparent shadow-xs text-sm font-medium rounded-md text-white bg-brand-600 hover:bg-brand-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-500"
                            >
                              Zmeniť
                            </button>
                          </div>
                        </div>
                      </form>

                      <div
                        id="toast-success"
                        class="flex items-center p-4 mb-4 w-full text-gray-500 bg-white rounded-lg shadow-xs dark:text-gray-400 dark:bg-gray-800"
                        role="alert"
                        v-show="showSuccess"
                      >
                        <div
                          class="inline-flex shrink-0 justify-center items-center size-8 text-green-500 bg-green-100 rounded-lg dark:bg-green-800 dark:text-green-200"
                        >
                          <svg
                            aria-hidden="true"
                            class="size-5"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                              clip-rule="evenodd"
                            ></path>
                          </svg>
                          <span class="sr-only">Check icon</span>
                        </div>
                        <div class="ml-3 text-sm font-normal">Heslo bolo úspešne zmenené.</div>
                        <button
                          type="button"
                          class="ml-auto -mx-1.5 -my-1.5 bg-white text-gray-400 hover:text-gray-900 rounded-lg focus:ring-2 focus:ring-gray-300 p-1.5 hover:bg-gray-100 inline-flex size-8 dark:text-gray-500 dark:hover:text-white dark:bg-gray-800 dark:hover:bg-gray-700"
                          data-dismiss-target="#toast-success"
                          aria-label="Close"
                          @click="showSuccess = false"
                        >
                          <span class="sr-only">Close</span>
                          <svg
                            aria-hidden="true"
                            class="size-5"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                              clip-rule="evenodd"
                            ></path>
                          </svg>
                        </button>
                      </div>

                      <div
                        id="toast-warning"
                        class="flex items-center p-4 w-full text-gray-500 bg-white rounded-lg shadow-xs dark:text-gray-400 dark:bg-gray-800"
                        role="alert"
                        v-show="showFailed"
                      >
                        <div
                          class="inline-flex shrink-0 justify-center items-center size-8 text-orange-500 bg-orange-100 rounded-lg dark:bg-orange-700 dark:text-orange-200"
                        >
                          <svg
                            aria-hidden="true"
                            class="size-5"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                              clip-rule="evenodd"
                            ></path>
                          </svg>
                          <span class="sr-only">Warning icon</span>
                        </div>
                        <div class="ml-3 text-sm font-normal">Došlo k chybe! Heslo nebolo zmenené.</div>
                        <button
                          type="button"
                          class="ml-auto -mx-1.5 -my-1.5 bg-white text-gray-400 hover:text-gray-900 rounded-lg focus:ring-2 focus:ring-gray-300 p-1.5 hover:bg-gray-100 inline-flex size-8 dark:text-gray-500 dark:hover:text-white dark:bg-gray-800 dark:hover:bg-gray-700"
                          data-dismiss-target="#toast-warning"
                          aria-label="Close"
                          @click="showFailed = false"
                        >
                          <span class="sr-only">Close</span>
                          <svg
                            aria-hidden="true"
                            class="size-5"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                              clip-rule="evenodd"
                            ></path>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
